import { Suspense, lazy } from 'react'

import Spinner from 'src/components/common/spinner'

import ErrorBoundary from './errorboundary'

const LoginPage = lazy(() => import('./login'))

const LoginViewContainer = (props) => {
    return (
        <div className="h-full w-full">
            <Suspense fallback={<Spinner />}>
                <ErrorBoundary>
                    <LoginPage {...props} />
                </ErrorBoundary>
            </Suspense>
        </div>
    )
}

export default LoginViewContainer
